module.exports = {
  "/": {
    "success": {
      "default": [
        "TODO_THIS_ALWAYS_REDIRECTS_WE_NEED_A_WAY_TO_HANDLE_THIS"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "rootView"
  },
  "/sales": {
    "success": {
      "default": [
        "SALES_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/service": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/marketing": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/growth-suite": {
    "name": "legacyGrowthSuitePage"
  },
  "/suite": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/cms": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/operations": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/bundle": {
    "success": {
      "default": [
        "BUNDLE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/crm": {
    "success": {
      "default": [
        "FREE_TOOLS_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "freeCRM"
  },
  "/confirm-suite-contacts": {
    "success": {
      "default": [
        "SUITE_CONTACTS_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "confirmSuiteContactsView"
  },
  "/confirm-contacts": {
    "success": {
      "default": [
        "CONTACTS_CONFIRMATION_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "confirmContactsView"
  },
  "/legacy-starter-confirmation": {
    "success": {
      "default": [
        "LEGACY_CONFIRMATION_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "legacyConfirmationView"
  }
};